import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const Row = ({ className, children, style }) => (
  <div className={classNames("row", className)} style={style}>
    {children}
  </div>
);

Row.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node.isRequired,
};

Row.defaultProps = {
  className: undefined,
};

export default Row;
